<template>
  <Page>
    <template #title>Справочники</template>
    <BaseNavigation class="mb-6" :items="menu" />

    <DictionaryForm :data="formData" />
  </Page>
</template>

<script>
  import {mapState} from 'vuex';

  import Page from '@/components/layouts/main/page';
  import DictionaryForm from '@/components/views/dictionary/form';
  import BaseNavigation from '@/components/global/base-navigation';

  export default {
    name: 'DictionaryRequestPage',

    components: {
      Page,
      BaseNavigation,
      DictionaryForm,
    },

    data() {
      return {
        menu: [
          {
            name: 'Заявка на добавление',
            link: 'dictionary.request',
          },
          {
            name: 'Просмотр заявок',
            link: 'dictionary.list',
          },
          {
            name: 'Условия',
            link: 'condition.list',
          },
        ],
      };
    },

    computed: {
      ...mapState('Auth', ['user']),

      formData() {
        return {
          fio: this.user.full_name,
          email: this.user.email,
          phone: this.user.phone,
        };
      },
    },
  };
</script>
